import classNames from 'classnames';
import { copywritingRow, copywritingText, innerContainer, outerContainer, publicationRow } from './Footer.css';
import type { FooterElementProps } from './Footer.type';
import { PublicationDetails } from './PublicationDetails';

export function FooterElement(props: FooterElementProps) {
  const { element } = props;
  const { data } = element;

  return (
    <footer className={outerContainer}>
      <div className={innerContainer}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem',
          }}
        >
          <div className={publicationRow}>
            <PublicationDetails
              publicationName={data.publicationName}
              publicationDescription={data.publicationDescription}
              publicationLogoURL={data.publicationLogoURL}
            />
            <div>{/* Menu */}</div>
            <div>{/* Sign up */}</div>
          </div>
          <div className={copywritingRow}>
            <div className="w-full text-center sm:w-1/2 sm:text-left">
              <p className={classNames(copywritingText)}>
                {/* TODO: internationalization */}
                {data.copyrightText || data.publicationName}
              </p>
            </div>

            <div className="flex w-full flex-col items-center gap-y-4 sm:w-1/2 sm:flex-row sm:justify-end sm:gap-x-4">
              <div className="flex gap-x-2 sm:gap-x-5">
                {/* TODO: Use components from apps */}
                {/* <PrivacyPolicy />
              <TermsOfUse /> */}
              </div>

              <div className="w-fit">
                {/* TODO: i18n */}
                <span>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`https://www.beehiiv.com/?utm_source=${data.publicationName}&utm_medium=footer`}
                    className="extra-light flex items-center rounded border border-gray-300 bg-white px-3 py-2 text-xs"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      background: 'white',
                      borderRadius: '.25rem',
                      paddingTop: '.5rem',
                      paddingBottom: '.5rem',
                      paddingLeft: '.75rem',
                      paddingRight: '.75rem',
                    }}
                  >
                    {/* TODO: Use Logo component */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      className="mr-2 h-4 w-4"
                      style={{
                        marginRight: '.5rem',
                        height: '1rem',
                        width: '1rem',
                      }}
                      viewBox="0 0 30 30"
                    >
                      <path
                        fill="#0B0D2A"
                        d="M25.692 13.168H3.866c-.556 0-1.01-.458-1.01-1.017V10.6c0-1.755 1.414-3.178 3.157-3.178H23.52c1.743 0 3.157 1.423 3.157 3.177v1.55a.98.98 0 0 1-.985 1.018ZM21.092 5.745H8.462a1.044 1.044 0 0 1-1.036-1.042C7.426 2.11 9.523 0 12.099 0h5.356c2.576 0 4.673 2.11 4.673 4.703 0 .584-.455 1.042-1.036 1.042ZM26.702 14.845H2.855C1.288 14.845 0 16.142 0 17.718c0 1.576 1.288 2.872 2.855 2.872h8.462c.303-1.627 1.718-2.872 3.436-2.872a3.532 3.532 0 0 1 3.46 2.872h8.463c1.567 0 2.855-1.296 2.855-2.872 0-1.576-1.263-2.873-2.83-2.873ZM25.663 22.268h-7.401v5.745h5.557c1.567 0 2.855-1.297 2.855-2.873v-1.83a1.006 1.006 0 0 0-1.01-1.042ZM3.864 22.268c-.556 0-1.036.457-1.036 1.042v1.83c0 1.576 1.288 2.873 2.855 2.873h5.557v-5.745H3.864Z"
                      />
                    </svg>
                    {/* TODO: i18n */}
                    <span style={{ color: 'black' }}>Powered by beehiiv</span>
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
